/** Exact-match spam flag reasons. */
export const VETTING_SPAM_FLAG_REASON = Object.freeze({
  DEVICE_REAPPLY_COOLDOWN: 'device_reapply_cooldown',
  ACCOUNT_REAPPLY_COOLDOWN: 'account_reapply_cooldown',
});

/** Prefix-match spam flag reasons (API may append suffixes, e.g. `_55s`, `_q1_q3`). */
export const VETTING_SPAM_FLAG_REASON_PREFIX = Object.freeze({
  IMPLAUSIBLE_UPLOAD_SPAN: 'implausible_upload_span',
  IDENTICAL_TRANSCRIPT_Q: 'identical_transcript_q',
});

export const VETTING_SPAM_FLAG_REASON_LABELS = Object.freeze({
  [VETTING_SPAM_FLAG_REASON.DEVICE_REAPPLY_COOLDOWN]:
    'Reapplied on the same device after rejection or waitlist',
  [VETTING_SPAM_FLAG_REASON.ACCOUNT_REAPPLY_COOLDOWN]:
    'Reapplied with the same account after rejection or waitlist',
});

export const VETTING_SPAM_FLAG_REASON_PREFIX_LABELS = Object.freeze({
  [VETTING_SPAM_FLAG_REASON_PREFIX.IMPLAUSIBLE_UPLOAD_SPAN]:
    'Videos uploaded too quickly (all five within about 1 minute)',
  [VETTING_SPAM_FLAG_REASON_PREFIX.IDENTICAL_TRANSCRIPT_Q]:
    'Two or more videos have similar or identical transcripts',
});

/**
 * Maps spamFlagReason to a human-readable message.
 * - Exact match: device_reapply_cooldown, account_reapply_cooldown
 * - Starts-with: implausible_upload_span*, identical_transcript_q*
 * - null / empty: null
 */
export const getVettingSpamFlagReasonLabel = (reason) => {
  if (reason == null) return null;

  const key = String(reason).trim().toLowerCase();
  if (!key) return null;

  if (VETTING_SPAM_FLAG_REASON_LABELS[key]) {
    return VETTING_SPAM_FLAG_REASON_LABELS[key];
  }

  const prefixMatch = Object.entries(VETTING_SPAM_FLAG_REASON_PREFIX_LABELS).find(([prefix]) =>
    key.startsWith(prefix),
  );
  if (prefixMatch) {
    return prefixMatch[1];
  }

  return key
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};
